/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { LawIdUserIEnumerableResponse } from '../models';
import { LawIdUserLsApiResponse } from '../models';
import { LawIdUserRequest } from '../models';
import { SearchLawIdUsersForExternalExaminerRequest } from '../models';
import { SearchLawIdUsersForTrustCoordinatorRequest } from '../models';
/**
 * LawIdApi - axios parameter creator
 * @export
 */
export const LawIdApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAll | Returns LawId User
         * @param {SearchLawIdUsersForExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2LawIdAdminSearchLawIdUsersForExternalExaminerPost: async (body?: SearchLawIdUsersForExternalExaminerRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/LawId/Admin/SearchLawIdUsersForExternalExaminer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns LawId User
         * @param {number} practiceId 
         * @param {SearchLawIdUsersForTrustCoordinatorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2LawIdAdminSearchLawIdUsersForTrustCoordinatorPracticeIdPost: async (practiceId: number, body?: SearchLawIdUsersForTrustCoordinatorRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2LawIdAdminSearchLawIdUsersForTrustCoordinatorPracticeIdPost.');
            }
            const localVarPath = `/api/v2/LawId/Admin/SearchLawIdUsersForTrustCoordinator/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Tester | Returns LawId Users
         * @param {LawIdUserRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2LawIdGetLawIdUsersPost: async (body?: LawIdUserRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/LawId/GetLawIdUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LawIdApi - functional programming interface
 * @export
 */
export const LawIdApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAll | Returns LawId User
         * @param {SearchLawIdUsersForExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2LawIdAdminSearchLawIdUsersForExternalExaminerPost(body?: SearchLawIdUsersForExternalExaminerRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LawIdUserLsApiResponse>> {
            const localVarAxiosArgs = await LawIdApiAxiosParamCreator(configuration).apiV2LawIdAdminSearchLawIdUsersForExternalExaminerPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns LawId User
         * @param {number} practiceId 
         * @param {SearchLawIdUsersForTrustCoordinatorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2LawIdAdminSearchLawIdUsersForTrustCoordinatorPracticeIdPost(practiceId: number, body?: SearchLawIdUsersForTrustCoordinatorRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LawIdUserLsApiResponse>> {
            const localVarAxiosArgs = await LawIdApiAxiosParamCreator(configuration).apiV2LawIdAdminSearchLawIdUsersForTrustCoordinatorPracticeIdPost(practiceId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Tester | Returns LawId Users
         * @param {LawIdUserRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2LawIdGetLawIdUsersPost(body?: LawIdUserRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LawIdUserIEnumerableResponse>> {
            const localVarAxiosArgs = await LawIdApiAxiosParamCreator(configuration).apiV2LawIdGetLawIdUsersPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LawIdApi - factory interface
 * @export
 */
export const LawIdApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TaAll | Returns LawId User
         * @param {SearchLawIdUsersForExternalExaminerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2LawIdAdminSearchLawIdUsersForExternalExaminerPost(body?: SearchLawIdUsersForExternalExaminerRequest, options?: any): AxiosPromise<LawIdUserLsApiResponse> {
            return LawIdApiFp(configuration).apiV2LawIdAdminSearchLawIdUsersForExternalExaminerPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns LawId User
         * @param {number} practiceId 
         * @param {SearchLawIdUsersForTrustCoordinatorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2LawIdAdminSearchLawIdUsersForTrustCoordinatorPracticeIdPost(practiceId: number, body?: SearchLawIdUsersForTrustCoordinatorRequest, options?: any): AxiosPromise<LawIdUserLsApiResponse> {
            return LawIdApiFp(configuration).apiV2LawIdAdminSearchLawIdUsersForTrustCoordinatorPracticeIdPost(practiceId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Tester | Returns LawId Users
         * @param {LawIdUserRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2LawIdGetLawIdUsersPost(body?: LawIdUserRequest, options?: any): AxiosPromise<LawIdUserIEnumerableResponse> {
            return LawIdApiFp(configuration).apiV2LawIdGetLawIdUsersPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LawIdApi - object-oriented interface
 * @export
 * @class LawIdApi
 * @extends {BaseAPI}
 */
export class LawIdApi extends BaseAPI {
    /**
     * 
     * @summary TaAll | Returns LawId User
     * @param {SearchLawIdUsersForExternalExaminerRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LawIdApi
     */
    public apiV2LawIdAdminSearchLawIdUsersForExternalExaminerPost(body?: SearchLawIdUsersForExternalExaminerRequest, options?: any) {
        return LawIdApiFp(this.configuration).apiV2LawIdAdminSearchLawIdUsersForExternalExaminerPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns LawId User
     * @param {number} practiceId 
     * @param {SearchLawIdUsersForTrustCoordinatorRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LawIdApi
     */
    public apiV2LawIdAdminSearchLawIdUsersForTrustCoordinatorPracticeIdPost(practiceId: number, body?: SearchLawIdUsersForTrustCoordinatorRequest, options?: any) {
        return LawIdApiFp(this.configuration).apiV2LawIdAdminSearchLawIdUsersForTrustCoordinatorPracticeIdPost(practiceId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Tester | Returns LawId Users
     * @param {LawIdUserRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LawIdApi
     */
    public apiV2LawIdGetLawIdUsersPost(body?: LawIdUserRequest, options?: any) {
        return LawIdApiFp(this.configuration).apiV2LawIdGetLawIdUsersPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
